import React from 'react';
import { useTranslation } from 'react-i18next';

export const NotFound = () => {
    const { t } = useTranslation();
    return (
        <div className="container text-center mt-5">
        <div className="row justify-content-center">
            <div className="col-md-8">
                <div className="card shadow-sm p-4">
                    <h1 className="display-4 text-danger">404</h1>
                    <h2>{t('notFound.heading')}</h2>
                    <p className="lead">{t('notFound.message')}</p>
                    <a href="/" className="btn btn-primary">{t('notFound.homeButton')}</a>
                </div>
            </div>
        </div>
    </div>
    );
};
